import React from 'react';
import { FaSearch } from 'react-icons/fa';
import styles from './Dashboard.module.css';
import { NotificationIcon } from '../index';
import { logout, signoff } from '../auth';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Space } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { getUserName } from '../utils/getUserName';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const Gheader = () => {
  const navigate = useNavigate();

  const handleMenuClick = ({ key }) => {
    if (key === '1') {
      toast.info('Signing out...', {
        autoClose: 1000,
        onClose: logout(),
      });
    }
  };

  const items = [
    {
      key: '1',
      label: <span>Sign out</span>,
    },
  ];

  return (
    <header className={styles.headerContainer}>
      <div className={styles.header}>
        <div className={styles.searchBarContainer}>
          {/* 
          <FaSearch />
          <input
            type="search"
            placeholder="Search for rooms and offers"
            className={styles.searchInput}
            aria-label="Search for rooms and offers"
          /> 
          */}
        </div>

        <div className={styles.headerActions}>
          {/* 
          <button
            aria-label="Notifications"
            className={styles.notificationButton}
          >
            <NotificationIcon />
          </button> 
          */}

          <Dropdown
            menu={{ items, onClick: handleMenuClick }}
            placement="bottomRight"
          >
            <div style={{ cursor: 'pointer' }}>
              <Space>
                <img
                  src="../images/user.avif"
                  alt="User profile"
                  className={styles.userAvatar}
                />
                <span className={styles.profileUsername}>{getUserName()}</span>
              </Space>
            </div>
          </Dropdown>
        </div>
      </div>
    </header>
  );
};
